module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "INTRODUCTION"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "p0003-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#con_1",
      "id": "toc_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0003-02-1"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOT HAS")]), _vm._v(" happened since the fall of 1990 when I sat at our kitchen table and jotted down a few pages of instructions and personal observations for my son, Adam. He was beginning his freshman year at college, and I felt that a collection of the insights and discoveries which had positively influenced my own life might be an appropriate gift to commemorate this important event.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0003-03-4"
    }
  }, [_vm._v("As a young adult, Adam would soon find himself standing at life’s most challenging crossroads. His choosing the right path would make all the difference. Here was my attempt to help his heart as well as his head to know the way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0003-03-5"
    }
  }, [_vm._v("That first list of fatherly advice contained 511 entries. I mailed him a new collection every two years. These lists were published as little books, and to my surprise and delight became bestsellers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0003-03-6"
    }
  }, [_vm._v("But Adam and I are most proud of the fact that this correspondence between us is now available in 28 languages and is valued by others throughout the world as a cherished reference and useful guide.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0003-03-7"
    }
  }, [_vm._v("This new edition brings together all three volumes of "), _c('em', [_vm._v("Life’s Little Instruction Book ")]), _vm._v("and offers them in what I think is a most handsome package. The rich, dark binding and gold "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("embossing certainly make the contents appear important. But Adam tells me he has always thought so. After reading a few pages, I hope you’ll agree."), _c('br')])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx33a",
    attrs: {
      "id": "p0004-02-2"
    }
  }, [_vm._v("H. J. B.")]), _vm._v(" "), _c('p', {
    staticClass: "tx33a",
    attrs: {
      "id": "p0004-02-3"
    }
  }, [_vm._v("Tall Pine Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "tx33a",
    attrs: {
      "id": "p0004-P-1"
    }
  }, [_vm._v("Fernvale, Tennessee")])])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 72
// module chunks = 0